import React, { useState, useEffect, useMemo } from "react";
import CustomTextField from "components/CustomTextField";
import { Row, Col, Card, Modal } from "react-bootstrap";
import {
  useGetAllFarmersInCropQuery,
  useCreateAggregationFpoMutation,
} from "./AggregationApiSlice";
import { DataGrid } from "@mui/x-data-grid";
import {
  Typography,
  Box,
  Divider,
  Button as ButtonMaterial,
} from "@mui/material";
import { faPenToSquare, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "reactstrap";
import { toast } from "react-toastify";

export const AggregationCropWise = ({
  crops,
  setDetailView,
  detailView,
  aggrigationId,
  setaggrigationId,
  setaggrigationDetails,
  fpo_name,
}) => {
  const [selectedCrop, setSelectedCrop] = useState("");
  const { data: cropList, refetch } = useGetAllFarmersInCropQuery(selectedCrop)
 ;

  const [modalOpen, setModalOpen] = useState(false);
  const [details, setDetails] = useState({});
  const [createAggregation] = useCreateAggregationFpoMutation();

  useEffect(() => {
    if (cropList) {
      refetch();
    }
  }, [cropList]);

  const columns = useMemo(() => [
    { field: "crop_name", headerName: "Crop Name", width: 190, sortable: true },
    {
      field: "created_at",
      headerName: "Created At",
      width: 130,
      sortable: true,
      renderCell: (params) => <div>{params.row.created_at.slice(0, 10)}</div>,
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 130,
      sortable: true,
      renderCell: (params) => <div>{params.row.updated_at.slice(0, 10)}</div>,
    },
    { field: "total_quantity", headerName: "Quantity", width: 130, sortable: true },
    { field: "season", headerName: "Season", width: 130, sortable: true },
    { field: "year", headerName: "Year", width: 130, sortable: true },
    {
      field: "stock_status",
      headerName: "Stock Status",
      width: 190,
      sortable: true,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{
            color:
              params.row.stock_status === "Procurement Done"
                ? "success.main"
                : params.row.stock_status === "Negotiation Done"
                ? "warning.main"
                : "primary.main",
            marginLeft: "8px",
          }}
        >
          {params.row.stock_status}
        </Typography>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 160,
      renderCell: (cellvalues) => (
        <FontAwesomeIcon
          icon={faPenToSquare}
          className="mx-2"
          style={{ color: "orange", fontSize: "16px", cursor: "pointer" }}
          onClick={() => {
            setDetailView(true);
            setaggrigationId(cellvalues.row.id);
            setaggrigationDetails(cellvalues.row);
          }}
        />
      ),
    },
  ], []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...details,
      fpo_name,
      year: parseInt(details.year),
    };
    try {
      await createAggregation(payload).unwrap();
      toast.success("Aggregation Created Successfully");
      refetch();
      setModalOpen(false);
    } catch {
      toast.error("Something went wrong!! We will get back soon");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "crop_name") {
      const selected = crops.find((item) => item.crop_code === value);
      setDetails({
        ...details,
        crop_id: selected?.crop_code,
        crop_name: selected?.crop_name,
      });
    } else {
      setDetails({
        ...details,
        [name]: value,
      });
    }
  };

  return (
    <div>
      <Row>
        <Col lg="2">
          <CustomTextField
            name="crop_name"
            type="select"
            className="mb-3"
            onChange={(e) => setSelectedCrop(e.target.value)}
          >
            <option value=""> --Select--</option>
            {crops?.map((item) => (
              <option key={item.crop_code} value={item.crop_name}>
                {item.crop_name}
              </option>
            ))}
          </CustomTextField>
        </Col>
        <Col lg="4" className="offset-md-6 mt-3">
          <div className="d-flex justify-content-end gap-2">
            <Button
              className="buttonOrangeDefaultColor"
              size="sm"
              onClick={() => setModalOpen(true)}
            >
              Create Aggregation&nbsp;
              <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i>
            </Button>
            <Button
              className="bg-transparent text-black fs-6 reloadButton"
              size="sm"
              onClick={refetch}
            >
              <FontAwesomeIcon icon={faRotateLeft} />
            </Button>
          </div>
        </Col>
      </Row>

      <DataGrid
        rows={cropList?.data || []}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 50 },
          },
        }}
        pageSizeOptions={[5]}
        disableRowSelectionOnClick
        autoHeight
      />

      <Modal show={modalOpen} onHide={() => setModalOpen(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Create Aggregation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="w-75 mx-auto p-4 mt-2">
            <Row className="bg-white p-3">
              <Col lg="6">
                <h4 className="text-center">Create an Aggregation </h4>
                <p className="text-muted mt-2">
                  "To participate in trade, you need to create an aggregation.
                  As an FPO (Farmer Producer Organization), you can aggregate
                  stock from multiple farmers and engage in bulk trading."
                </p>
                <div className="d-flex justify-content-center">
                  <div
                    className="p-3 mt-5 w-50 text-center rounded"
                    style={{ backgroundColor: "#f1f1f1", border: "1px solid #ddd" }}
                  >
                    <h6>Participate.. </h6>
                    <p>
                      Start by adding crop details and initiating the process.
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg="6" className="d-flex flex-column gap-2">
                <form onSubmit={handleSubmit}>
                  <CustomTextField
                    name="crop_name"
                    label="Crop Name"
                    type="select"
                    required
                    className="mb-3"
                    onChange={handleChange}
                  >
                    <option value=""> --Select--</option>
                    {crops?.map((item) => (
                      <option key={item.crop_code} value={item.crop_code}>
                        {item.crop_name}
                      </option>
                    ))}
                  </CustomTextField>
                  <CustomTextField
                    name="season"
                    label="Season"
                    type="select"
                    required
                    className="mb-3"
                    onChange={handleChange}
                  >
                    <option value=""> --Select--</option>
                    <option value="Rabi"> Rabi</option>
                    <option value="Kharif"> Kharif</option>
                    <option value="Zaid"> Zaid</option>
                  </CustomTextField>
                  <CustomTextField
                    name="year"
                    label="Year"
                    type="select"
                    required
                    onChange={handleChange}
                  >
                    <option value=""> --Select--</option>
                    <option value="2025"> 2025</option>
                    <option value="2024"> 2024</option>
                    <option value="2023"> 2023</option>
                  </CustomTextField>
                  <Divider />
                  <ButtonMaterial
                    variant="contained"
                    color="success"
                    size="small"
                    type="submit"
                    className="text-center mt-4"
                  >
                    Create
                  </ButtonMaterial>
                </form>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
